// Module
var code = " <ng-template> <ng-content></ng-content> </ng-template>";
// Exports
module.exports = code;